// Video Player
export let videoPlayer = () => {

    var videoPlayer = $('.news-videos iframe'),
        videoItem = $('.news-videos__item'),
        videoItemFirst = $('.news-videos__item:first-child');

    $(document).ready( () => {
        var initVideoItemURL = videoItemFirst.attr('data-url') + '?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';
        
        videoPlayer.attr('src', initVideoItemURL); 
        videoItemFirst.addClass('news-videos__item--active');
        videoItemFirst.find('.cms-link').text('Now Playing');
    });

    videoItem.on('click keypress', function(e){
        e.preventDefault();
        
        var videoItemURL = $(this).attr('data-url') + '?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

        videoItem.removeClass('news-videos__item--active');
        videoItem.find('.cms-link').text('Watch');

        $(this).addClass('news-videos__item--active');
        $(this).find('.cms-link').text('Now Playing');

        videoPlayer.css('opacity', 0);


        setTimeout(() => {
            videoPlayer.attr('src', videoItemURL);  
        }, 1000);

        setTimeout(() => {
            videoPlayer.css('opacity', 1);
        }, 1500);

    });             

};